// Friends module translation - English
export default {
  friends: {
    title: 'Friends',
    subtitle: 'Manage your friendships',
    addFriend: 'Add Friend',
    noFriends: 'No friends yet',
    addFriendsHint: 'Add friends to share expenses together!',
    unknownUser: 'Unknown User',
    removeFriend: 'Remove Friend',
    confirmRemove: 'Confirm removing friend?',
    removeSuccess: 'Friend removed successfully',
    removedFriend: 'Removed friend {name}',
    
    // Tags
    tagsUpdated: 'Friend tags updated successfully',
    allFriends: 'All',
    noTaggedFriends: 'No friends with "{tag}" tag',
    tryOtherTags: 'Try selecting other tags or add new friends',
    
    // Loading states
    loading: {
      title: 'Connecting friends...',
      subtitle: 'Loading your friend information',
    },
    // Tag Editor
    editTags: 'Edit Friend Tags',
    selectedTags: 'Selected Tags',
    presetTags: 'Preset Tags',
    myTags: 'My Tags',
    addCustomTag: 'Add Custom Tag',
    tagInputPlaceholder: 'Enter tag name (e.g., Gym Buddy)',
    tagHelp: 'Tag Help',
    tagAlreadyExists: 'This tag already exists',
    tagSaveSuccess: 'Friend tags updated successfully',
    tagSaveError: 'Save failed',
    saving: 'Saving...',
    save: 'Save',
    noTagsSelected: 'No tags selected',
    success: 'Success',
    error: 'Error',
    tagHelpText: `• Tags help you categorize and manage friends
• You can quickly select invitees by tags when creating group meals
• One friend can have multiple tags
• Recommend using short and clear tag names`,
    
    // Preset tag translations
    presetTagCoworker: 'Coworker',
    presetTagClassmate: 'Classmate', 
    presetTagNeighbor: 'Neighbor',
    presetTagRoommate: 'Roommate',
    presetTagFamily: 'Family',
    presetTagGymBuddy: 'Gym Buddy',
    presetTagGameBuddy: 'Game Buddy',
    presetTagLunchBuddy: 'Lunch Buddy',
    presetTagTravelBuddy: 'Travel Buddy',
    presetTagStudyBuddy: 'Study Buddy',
    presetTagWorkPartner: 'Work Partner',
    
    // Search and add
    contactLabel: 'Contact Information',
    contactPlaceholder: 'Enter email, username, or phone number',
    searchPlaceholder: 'Search username, email, or phone',
    searchEmpty: 'No users found',
    searchError: 'Search failed, please try again later',
    searchHint: 'Enter complete information for more accurate search results',
    searching: 'Searching...',
    searchResults: 'Search Results',
    addByContact: 'Add by contact info',
    scanQRCode: 'Scan QR code to add',
    shareMyQR: 'Share my QR code',
    sendRequest: 'Send Friend Request',
    
    // Friend request message
    messageLabel: 'Friend Request Message (Optional)',
    messagePlaceholder: 'Introduce yourself to make it easier for them to accept your friend request',
    
    // Status messages
    loadFailed: 'Failed to load friends list',
    searchFailed: 'Search failed',
    incompleteUserInfo: 'Incomplete user information',
    enterContactInfo: 'Please enter email, username, or phone number',
    requestSent: 'Friend request sent successfully!',
    requestFailed: 'Failed to send friend request',
    removeFailed: 'Failed to remove friend',
  }
};
